export function debounce(fn, delay = 350) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), delay);
  };
}

export function parseMoneyInput(raw) {
  const digits = String(raw ?? '').replaceAll(/[^\d]/g, '');
  return digits ? Number(digits) : 0;
}

export function clamp(n, min, max) {
  const num = Number(n);
  const lo = Number(min);
  const hi = Number(max);
  if (!Number.isFinite(num)) return lo;
  return Math.min(hi, Math.max(lo, num));
}

export function formReveal(configs) {
  for (const { block, contentSelector } of configs) {
    const buttons = document.querySelectorAll(`${block} .gravity-button`);
    if (!buttons.length) continue;
    for (const btn of buttons) {
      btn.addEventListener('click', () => {
        const content = document.querySelector(`${block} ${contentSelector}`);
        const container = document.querySelector(`${block} .gravity-container`);

        if (!content || !container) return;

        content.style.transition = 'opacity 0.5s ease';
        container.style.transition = 'opacity 0.5s ease';

        content.style.opacity = '0';
        content.style.visibility = 'hidden';

        container.style.opacity = '1';
        container.style.visibility = 'visible';

        setTimeout(() => {
          for (const b of document.querySelectorAll(`${block} .gravity-button`)) b.remove();
        }, 500);
      });
    }
  }
}
